import React from 'react';
import { IconBox, IconProps } from 'src/lib/IconBox';

const LockIcon = (props: IconProps) => (
  <IconBox {...props}>
    <path
      fillRule="evenodd"
      d="M11.7273 32c-1.6067 0-2.90912 1.3024-2.90912 2.9091v20.3636c0 1.6067 1.30242 2.9091 2.90912 2.9091h40.7272c1.6067 0 2.9091-1.3024 2.9091-2.9091V34.9091c0-1.6067-1.3024-2.9091-2.9091-2.9091H11.7273zM3 34.9091c0-4.8199 3.90733-8.7273 8.7273-8.7273h40.7272c4.82 0 8.7273 3.9074 8.7273 8.7273v20.3636c0 4.82-3.9073 8.7273-8.7273 8.7273H11.7273C6.90733 64 3 60.0927 3 55.2727V34.9091z"
      clipRule="evenodd"
    />
    <path
      fillRule="evenodd"
      d="M32.0909 5.81818c-3.0861 0-6.0459 1.22597-8.2281 3.40821-2.1823 2.18221-3.4083 5.14201-3.4083 8.22811v11.6364c0 1.6067-1.3024 2.9091-2.909 2.9091-1.6067 0-2.9091-1.3024-2.9091-2.9091V17.4545c0-4.6292 1.8389-9.06882 5.1123-12.34218C23.022 1.83896 27.4617 0 32.0909 0s9.0689 1.83896 12.3422 5.11232c3.2734 3.27336 5.1124 7.71298 5.1124 12.34218v11.6364c0 1.6067-1.3025 2.9091-2.9091 2.9091-1.6067 0-2.9091-1.3024-2.9091-2.9091V17.4545c0-3.0861-1.226-6.0459-3.4082-8.22811-2.1823-2.18224-5.142-3.40821-8.2282-3.40821z"
      clipRule="evenodd"
    />
  </IconBox>
);

export default LockIcon;
